export default "__VITE_ASSET__8T3JJf2m__"